<div class="team-select"
     [class.tv-style]="mode() === 'teams'"
     [class.home-style]="mode() === 'home'"
     [class.home-card]="mode() === 'home' && !isEmpty()"
     [class.drop-down]="dropDown()"
     [class.compact]="compact()"
     [class.open]="isOpen()"
     [class.empty]="isEmpty()"
     (click)="toggleOpen()">
  @if (isEmpty()) {
    <div class="team-current">
      <span class="label placeholder">No team yet</span>
    </div>
    <span class="route-hint">Set up →</span>
  } @else if (mode() === 'home') {
    <button type="button" class="tb-head" (click)="$event.stopPropagation(); toggleOpen()">
      @if (active()?.isDefault) {
        <span class="default-mark" title="Default team">★</span>
      }
      <span class="label">{{ active()?.name ?? 'No team' }}</span>
      <span class="switch-hint">Switch</span>
      <span class="caret">▾</span>
    </button>
    <div class="tb-body" (click)="$event.stopPropagation()">
      <div class="lineup">
        @for (m of lineup(); track $index) {
          <a class="slot" [routerLink]="['/teams', 'mon', m.id]" [title]="'Edit ' + m.name + ' in Teams'">
            <span class="sprite-wrap">
              <app-mon-static-sprite
                [monId]="m.id"
                spriteType="mini"
                [displayWidth]="compact() ? 32 : 64"
                [displayHeight]="compact() ? 32 : 64" />
              @if (mobile.isMobile && !compact()) {
                <span class="lv-badge">{{ m.level ?? '—' }}</span>
              }
            </span>
            @if (!mobile.isMobile && !compact()) {
              <span class="m-caption">
                <span class="m-id"><span class="m-name">{{ m.name }}</span></span>
                <span class="m-lv"><span class="k">Lv</span><span class="n">{{ m.level ?? '—' }}</span></span>
                @if (m.facet; as f) {
                  <span class="m-facet" [title]="f.name"><span class="m-facet-glyph">{{ f.glyph }}</span>{{ abbrevFacet(f.name) }}</span>
                } @else {
                  <span class="m-no-facet ui-label">No Facet</span>
                }
                @if (m.fx; as fx) {
                  <span class="m-fx">
                    <span class="up">+{{ fx.boostPct }}% {{ fx.boostStat }}</span>
                    <span class="down">−{{ fx.nerfPct }}% {{ fx.nerfStat }}</span>
                  </span>
                }
              </span>
            }
          </a>
        }
      </div>
    </div>
  } @else {
    <div class="team-current">
      @if (headerIsDefault()) {
        <span class="default-mark" title="Default team">★</span>
      }
      <span class="label">{{ headerName() }}</span>
    </div>
    <span class="caret">▾</span>
  }

  @if (isOpen() && !mobile.isMobile) {
    <div class="team-dropdown" (click)="$event.stopPropagation()">
      <div class="team-dropdown-title ui-label">
        <span>
          {{ mode() === 'home' ? 'SWITCH TEAM' : 'YOUR TEAMS' }}
          @if (mode() === 'teams') {
            <span class="count">· {{ teamList.teams().length }} / {{ MAX_TEAMS }}</span>
          }
        </span>
        @if (mode() === 'home') {
          <a class="manage-link" routerLink="/teams" (click)="closeDropdown()">Manage in /teams →</a>
        }
      </div>

      <div class="team-dropdown-rows">
        @for (team of rows(); track team.slot) {
          <button class="team-row"
                  [class.active]="team.isActive"
                  (click)="selectRow(team.slot)">
            <span class="row-head">
              @if (team.isDefault) {
                <span class="default-mark">★</span>
              }
              <span class="row-name">{{ team.name }}</span>
            </span>
            <span class="row-mons">
              @for (m of team.mons; track $index) {
                <span class="mon-cell">
                  <app-mon-static-sprite [monId]="m.id" spriteType="mini" [displayWidth]="32" [displayHeight]="32" />
                  <span class="mon-cell-name" [title]="m.name">{{ m.name }}</span>
                  <span class="mon-cell-meta">
                    <span>Lv {{ m.level ?? '—' }}</span>
                    @if (m.facet; as f) {
                      <span class="mon-cell-facet" [title]="f.name">{{ f.glyph }}</span>
                    }
                  </span>
                </span>
              }
            </span>
          </button>
        }
      </div>

      @if (mode() === 'teams') {
        <div class="team-dropdown-footer">
          <button class="new-team-btn"
                  [disabled]="teamList.teams().length >= MAX_TEAMS || teamList.draftSlot() !== null"
                  (click)="newTeam()">
            + NEW TEAM
          </button>
        </div>
      }
    </div>
  }
</div>

@if (isOpen() && mobile.isMobile) {
  <app-team-select-sheet [mode]="mode()" (close)="closeDropdown()" />
}
